export const Roles = {
    "General Manager": "gm",
    "Marketing Manager": "marketing",
    "Learning and Development manager":"learning_development",
    "ADMIN": "super-admin"
  }